<template>
    <div class="layout | nav-tabs | u-margin-bottom u-margin-left-flush">
        <div :class="{ 'is-active': step == 1 }" class="layout__item u-1/4-portable u-1/4-desk | nav-tabs__item">
            <span class="nav-tabs__title | u-display--none-portable">
                <customer-router-link class="link-tabs" :to="{ name: 'orderFullDomain' }">
                    {{ trans('order.tabs.domain-name') }}
                </customer-router-link>
            </span>
            <span :class="{ 'is-active': step >= 1 }" class="nav-tabs__meter" />
            <span
                :class="{ 'u-display--none-portable': step != 1 }"
                class="nav-tabs__title | u-text-center u-display--none-desk"
            >
                <customer-router-link class="link-tabs" :to="{ name: 'orderFullDomain' }">
                    {{ trans('order.tabs.domain-name') }}
                </customer-router-link>
            </span>
        </div>
        <!--
     -->
        <div :class="{ 'is-active': step == 2 }" class="layout__item u-1/4-portable u-1/4-desk | nav-tabs__item">
            <span class="nav-tabs__title | u-display--none-portable">
                <customer-router-link class="link-tabs" :to="{ name: 'orderFullHosting' }">
                    {{ trans('order.tabs.hosting') }}
                </customer-router-link>
            </span>
            <span :class="{ 'is-active': step >= 2 }" class="nav-tabs__meter" />
            <span
                :class="{ 'u-display--none-portable': step != 2 }"
                class="nav-tabs__title | u-text-center u-display--none-desk"
            >
                <customer-router-link class="link-tabs" :to="{ name: 'orderFullHosting' }">
                    {{ trans('order.tabs.hosting') }}
                </customer-router-link>
            </span>
        </div>
        <!--
     -->
        <div :class="{ 'is-active': step == 3 }" class="layout__item u-1/4-portable u-1/4-desk | nav-tabs__item">
            <span class="nav-tabs__title | u-display--none-portable">
                <customer-router-link class="link-tabs" :to="{ name: 'orderFullSsl' }">
                    {{ trans('order.tabs.ssl') }}
                </customer-router-link>
            </span>
            <span :class="{ 'is-active': step >= 3 }" class="nav-tabs__meter" />
            <span
                :class="{ 'u-display--none-portable': step != 3 }"
                class="nav-tabs__title | u-text-center u-display--none-desk"
            >
                <customer-router-link class="link-tabs" :to="{ name: 'orderFullSsl' }">
                    {{ trans('order.tabs.ssl') }}
                </customer-router-link>
            </span>
        </div>
        <!--
     -->
        <div :class="{ 'is-active': step == 4 }" class="layout__item u-1/4-portable u-1/4-desk | nav-tabs__item">
            <span class="nav-tabs__title | u-display--none-portable">
                <customer-router-link class="link-tabs" :to="{ name: 'orderFullOverview' }">
                    {{ trans('order.tabs.overview') }}
                </customer-router-link>
            </span>
            <span :class="{ 'is-active': step >= 4 }" class="nav-tabs__meter" />
            <span
                :class="{ 'u-display--none-portable': step != 4 }"
                class="nav-tabs__title | u-text-center u-display--none-desk"
            >
                <customer-router-link class="link-tabs" :to="{ name: 'orderFullOverview' }">
                    {{ trans('order.tabs.overview') }}
                </customer-router-link>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        step: Number
    }
};
</script>
